// Central content for the Home Entry. NL first; en/de/fr/es slots prepared.
export const HOME_ENTRY_IMAGES = {
  gate: {
    slug: "home-entry-gate",
    url: "https://customer-assets.emergentagent.com/job_virtue-guide-demo/artifacts/i95lbpzs_IMG_4859.jpeg",
    alt: "Een man staat voor een monumentale toegangspoort met de woorden Know Thyself.",
  },
  courtyard: {
    slug: "home-entry-courtyard",
    url: "https://static.prod-images.emergentagent.com/jobs/1d5a75bf-247b-4978-bd96-c3cab95490ad/images/78f69cd7887c9601bbbb82bba4f89cd47a20d7ae5415d206396b6b252e2f60bf.jpeg",
    alt: "De man loopt door de poort naar een binnenplaats waar Hipparchia in de verte wacht.",
    aspectRatio: "1264 / 848",
  },
  welcome: {
    slug: "home-entry-hipparchia-welcome",
    url: "https://customer-assets-jt897jd0.emergentagent.net/job_virtue-guide-demo/artifacts/buvhpbxc_IMG_7576.jpeg",
    alt: "Hipparchia verwelkomt de bezoeker met een uitgestoken hand.",
    mobile: {
      url: "https://static.prod-images.emergentagent.com/jobs/1d5a75bf-247b-4978-bd96-c3cab95490ad/images/988ccac1a3875fcbc1289bb18c1889ef492fe1b71d9c6eb9e949d11977c2d3dd.jpeg",
    },
  },
};

export const APPSTORE_URL = "https://apps.apple.com/app/virtue-guide/id6777389425";
export const ANDROID_NOTE_VISIBLE = true; // flip when Google Play arrives

const nl = {
  scene1: {
    pre: "Iedere zoektocht naar wijsheid begint met één eerlijke vraag.",
    h1: "Wie ben ik werkelijk?",
    body: ["Niet wie anderen zeggen dat u bent.", "Niet uw functie, bezit, succes of verleden.", "Maar wie u kiest te zijn wanneer het leven u op de proef stelt."],
    scrollHint: "Scroll om de Stoa binnen te gaan.",
  },
  scene2: {
    title: "U heeft de poort gepasseerd.",
    intro: ["Niet om aan het leven te ontsnappen,", "maar om het helderder tegemoet te treden."],
    line: "Hier zoeken wij niet naar snelle antwoorden.",
    triad: ["Wij leren beter waarnemen.", "Wij leren beter oordelen.", "Wij leren beter handelen."],
  },
  scene3: {
    title: "Welkom.",
    name: "Mijn naam is Hipparchia.",
    p1: "Meer dan tweeduizend jaar geleden koos ik ervoor mijn leven niet te laten bepalen door verwachtingen, bezit of maatschappelijke status.",
    p2: ["Ik koos voor wijsheid.", "Voor eenvoud.", "Voor innerlijke vrijheid."],
    p3: "Namens Marcus Aurelius, Epictetus, Seneca en de andere leraren van de Stoa heet ik u welkom bij StoicOs.ai.",
    promptLead: "Vertel mij...",
    prompt: "Wat heeft u vandaag naar StoicOs.ai gebracht?",
  },
  q1: {
    eyebrow: "Mag ik u iets vragen?",
    question: "Wat heeft u vandaag naar StoicOs.ai gebracht?",
    options: {
      A: "Ik zoek meer rust en innerlijke vrijheid.",
      B: "Ik wil sterker leren omgaan met tegenslag en verandering.",
      C: "Ik wil mijzelf, mijn gedachten en mijn keuzes beter begrijpen.",
      D: "Ik ben nieuwsgierig naar het stoïcisme.",
      E: "Ik wil mij ontwikkelen als leider, ondernemer of mens.",
      F: "Ik weet het nog niet. Ik wil eerst ontdekken wat StoicOs.ai is.",
    },
  },
  branches: {
    A: {
      question: "Waar ervaart u momenteel de meeste onrust?",
      options: ["In mijn gedachten.", "Door werk of verantwoordelijkheid.", "Door relaties of andere mensen.", "Door onzekerheid over de toekomst.", "Ik kan het nog niet precies benoemen."],
      reaction: "Dank u voor uw eerlijkheid.\nInnerlijke rust ontstaat niet doordat alle problemen verdwijnen.\nZij ontstaat wanneer u leert onderscheiden wat werkelijk van u is, welke oordelen u zelf toevoegt en waar u uw aandacht op wilt richten.",
    },
    B: {
      question: "Wat wilt u vooral leren?",
      options: ["Rustiger reageren wanneer iets tegenzit.", "Omgaan met verlies of verandering.", "Minder afhankelijk worden van omstandigheden.", "Mijn moed en veerkracht versterken.", "Ik weet het nog niet precies."],
      reaction: "Tegenslag onthult niet alleen wat ons overkomt.\nZij onthult ook welke overtuigingen, verwachtingen en angsten ons van binnen aansturen.\nDe Stoa leert ons niet ongevoelig te worden, maar steviger te leren staan.",
    },
    C: {
      question: "Waarover wilt u meer helderheid krijgen?",
      options: ["Mijn gedachten en emoties.", "Mijn terugkerende patronen.", "Mijn beslissingen.", "Mijn waarden en karakter.", "Mijn richting in het leven."],
      reaction: "Zelfkennis begint niet met een oordeel over wie u bent.\nZij begint met aandacht.\nDoor uw indrukken, gedachten en keuzes te onderzoeken, wordt zichtbaar wat u bewust wilt behouden en wat u niet langer hoeft te volgen.",
    },
    D: {
      question: "Wat spreekt u het meeste aan?",
      options: ["De oude filosofen.", "Praktische wijsheid voor het dagelijks leven.", "Discipline en mentale kracht.", "De vier deugden.", "Ik weet nog bijna niets over de Stoa."],
      reaction: "Nieuwsgierigheid is een waardig begin.\nU hoeft nog niets te geloven of zeker te weten.\nBinnen de Stoa wordt u uitgenodigd om te onderzoeken, te oefenen en zelf te beoordelen welke inzichten standhouden in het dagelijks leven.",
    },
    E: {
      question: "Wat wilt u als eerste versterken?",
      options: ["Helderder beslissen.", "Rust bewaren onder druk.", "Rechtvaardiger leidinggeven.", "Beter omgaan met conflicten.", "Meer discipline en zelfbeheersing ontwikkelen."],
      reaction: "Leiderschap begint niet bij macht over anderen.\nHet begint bij leiding over uw eigen oordeel, gedrag en karakter.\nWie zichzelf niet kan leiden, zal ook anderen moeilijk met wijsheid kunnen dienen.",
    },
    F: {
      question: null,
      options: [],
      reaction: "Dat geeft niets.\nWijsheid begint zelden met zekerheid.\nVaak begint zij met het eerlijke besef dat wij nog niet precies weten waarnaar wij zoeken.\nNeem gerust de tijd.\nU hoeft vandaag niets te beslissen.",
    },
  },
  advice: {
    title: "Een passende eerste stap",
    standard: "Op basis van wat u mij heeft verteld, stel ik voor dat u begint met de eerste les van Logica.\nNiet omdat alle antwoorden daar worden gegeven.\nMaar omdat helder leren denken het begin vormt van iedere verdere stap.",
    bullets: ["wat u werkelijk waarneemt;", "welke betekenis u daar zelf aan geeft;", "en wanneer u wel of niet met een eerste indruk moet instemmen."],
    bulletsIntro: "In deze eerste les leert u onderzoeken:",
    free: "U kunt deze kennismakingsles gratis volgen.",
    soft: "U hoeft vandaag nog niets definitief te kiezen.\nWanneer u toch een eerste stap wilt zetten, stel ik voor dat u rustig kennismaakt met de eerste les van Logica.\nDaar begint de oefening niet met antwoorden, maar met helder leren kijken.",
  },
  paths: {
    title: "Hoe wilt u beginnen?",
    intro: ["Iedere weg naar wijsheid begint anders.", "Kies de eerste stap die op dit moment bij u past."],
    cards: [
      { id: "logic", title: "Begin met de eerste les Logica", body: "Maak gratis kennis met de fundamenten van helder waarnemen, onderzoeken en oordelen.", cta: "Probeer de eerste les" },
      { id: "mystoicos", title: "Ontmoet uw mentoren en begin uw dagboek", body: "Maak kennis met Marcus Aurelius, Epictetus, Seneca en Hipparchia.\nGebruik het dagboek om uw gedachten, keuzes en dagelijkse ervaringen te onderzoeken.", cta: "Maak een gratis account aan in My StoicOs", ctaLoggedIn: "Open My StoicOs" },
      { id: "virtueguide", title: "Download de gratis Virtue Guide", body: "Neem de stoïcijnse praktijk mee in het dagelijks leven.\nGebruik de Virtue Guide voor dagelijkse reflectie, begeleiding en praktische oefeningen op uw telefoon.", cta: "Download Virtue Guide gratis", note: "Beschikbaar in de Apple App Store en op Google Play." },
      { id: "newsletter", title: "Ik wil eerst rustig kennismaken", body: "Misschien wilt u alles eerst laten bezinken.\nDat is geen probleem.\nNeem gerust de tijd om te bepalen of u het pad van praktische wijsheid wilt bewandelen.", extra: "Via onze nieuwsbrief ontvangt u rustige, inhoudelijke bijdragen over praktische wijsheid en de toepassing van de Stoa in het moderne leven.", cta: "Ontvang de nieuwsbrief", unsub: "U kunt zich op ieder moment weer uitschrijven." },
    ],
  },
  closing: {
    lines: ["Welke eerste stap u ook kiest:", "u hoeft vandaag niet volmaakt te zijn.", "U hoeft alleen bereid te zijn eerlijk te kijken, zorgvuldig te onderzoeken en bewust te kiezen wie u wilt zijn."],
    emphasis: "De poort staat open.",
    big: "Welkom bij StoicOs.ai",
    sub: "Innerlijke vrijheid is de bestemming.",
  },
  changeAnswer: "Wijzig mijn antwoord",
};

// British English translation — mirrors the NL structure line for line.
const en = {
  scene1: {
    pre: "Every search for wisdom begins with one honest question.",
    h1: "Who am I, truly?",
    body: ["Not who others say you are.", "Not your title, possessions, success or past.", "But who you choose to be when life puts you to the test."],
    scrollHint: "Scroll to enter the Stoa.",
  },
  scene2: {
    title: "You have passed through the gate.",
    intro: ["Not to escape from life,", "but to meet it with greater clarity."],
    line: "Here we do not look for quick answers.",
    triad: ["We learn to observe more clearly.", "We learn to judge more wisely.", "We learn to act more deliberately."],
  },
  scene3: {
    title: "Welcome.",
    name: "My name is Hipparchia.",
    p1: "More than two thousand years ago, I chose not to let my life be defined by expectations, possessions or social status.",
    p2: ["I chose wisdom.", "Simplicity.", "Inner freedom."],
    p3: "On behalf of Marcus Aurelius, Epictetus, Seneca and the other teachers of the Stoa, I welcome you to StoicOs.ai.",
    promptLead: "Tell me...",
    prompt: "What has brought you to StoicOs.ai today?",
  },
  q1: {
    eyebrow: "May I ask you something?",
    question: "What has brought you to StoicOs.ai today?",
    options: {
      A: "I am looking for more calm and inner freedom.",
      B: "I want to grow stronger in facing adversity and change.",
      C: "I want to understand myself, my thoughts and my choices better.",
      D: "I am curious about Stoicism.",
      E: "I want to develop as a leader, an entrepreneur or a human being.",
      F: "I do not know yet. I first want to discover what StoicOs.ai is.",
    },
  },
  branches: {
    A: {
      question: "Where do you currently experience the most unrest?",
      options: ["In my thoughts.", "Through work or responsibility.", "Through relationships or other people.", "Through uncertainty about the future.", "I cannot quite name it yet."],
      reaction: "Thank you for your honesty.\nInner calm does not arise because all problems disappear.\nIt arises when you learn to distinguish what is truly yours, which judgements you add yourself, and where you wish to direct your attention.",
    },
    B: {
      question: "What would you most like to learn?",
      options: ["To respond more calmly when things go against me.", "To deal with loss or change.", "To become less dependent on circumstances.", "To strengthen my courage and resilience.", "I do not know precisely yet."],
      reaction: "Adversity does not only reveal what happens to us.\nIt also reveals which beliefs, expectations and fears steer us from within.\nThe Stoa does not teach us to become unfeeling, but to learn to stand more firmly.",
    },
    C: {
      question: "What would you like to see more clearly?",
      options: ["My thoughts and emotions.", "My recurring patterns.", "My decisions.", "My values and character.", "My direction in life."],
      reaction: "Self-knowledge does not begin with a judgement about who you are.\nIt begins with attention.\nBy examining your impressions, thoughts and choices, it becomes visible what you consciously wish to keep and what you no longer need to follow.",
    },
    D: {
      question: "What appeals to you most?",
      options: ["The ancient philosophers.", "Practical wisdom for daily life.", "Discipline and mental strength.", "The four virtues.", "I know almost nothing about the Stoa yet."],
      reaction: "Curiosity is a worthy beginning.\nYou need not believe or be certain of anything yet.\nWithin the Stoa you are invited to examine, to practise and to judge for yourself which insights hold true in daily life.",
    },
    E: {
      question: "What would you like to strengthen first?",
      options: ["Deciding with greater clarity.", "Keeping calm under pressure.", "Leading more justly.", "Handling conflict better.", "Developing more discipline and self-control."],
      reaction: "Leadership does not begin with power over others.\nIt begins with guidance over your own judgement, conduct and character.\nThose who cannot lead themselves will find it hard to serve others with wisdom.",
    },
    F: {
      question: null,
      options: [],
      reaction: "That is quite all right.\nWisdom rarely begins with certainty.\nOften it begins with the honest realisation that we do not yet know precisely what we are looking for.\nDo take your time.\nYou need not decide anything today.",
    },
  },
  advice: {
    title: "A fitting first step",
    standard: "Based on what you have told me, I suggest you begin with the first lesson of Logic.\nNot because all the answers are given there.\nBut because learning to think clearly is the beginning of every further step.",
    bullets: ["what you actually perceive;", "which meaning you yourself attach to it;", "and when you should or should not assent to a first impression."],
    bulletsIntro: "In this first lesson you learn to examine:",
    free: "You can follow this introductory lesson free of charge.",
    soft: "You need not decide anything definitive today.\nShould you wish to take a first step, I suggest you quietly acquaint yourself with the first lesson of Logic.\nThere, the practice begins not with answers, but with learning to see clearly.",
  },
  paths: {
    title: "How would you like to begin?",
    intro: ["Every path to wisdom begins differently.", "Choose the first step that suits you at this moment."],
    cards: [
      { id: "logic", title: "Begin with the first lesson of Logic", body: "Get acquainted, free of charge, with the foundations of clear perception, examination and judgement.", cta: "Try the first lesson" },
      { id: "mystoicos", title: "Meet your mentors and begin your journal", body: "Meet Marcus Aurelius, Epictetus, Seneca and Hipparchia.\nUse the journal to examine your thoughts, choices and daily experiences.", cta: "Create a free account in My StoicOs", ctaLoggedIn: "Open My StoicOs" },
      { id: "virtueguide", title: "Download the free Virtue Guide", body: "Take the Stoic practice with you into daily life.\nUse the Virtue Guide for daily reflection, guidance and practical exercises on your phone.", cta: "Download Virtue Guide for free", note: "Available on the Apple App Store and Google Play." },
      { id: "newsletter", title: "I would first like to take my time", body: "Perhaps you would like to let it all sink in first.\nThat is no problem at all.\nDo take the time to decide whether you wish to walk the path of practical wisdom.", extra: "Through our newsletter you will receive calm, substantive contributions on practical wisdom and the application of the Stoa in modern life.", cta: "Receive the newsletter", unsub: "You can unsubscribe again at any moment." },
    ],
  },
  closing: {
    lines: ["Whichever first step you choose:", "you need not be perfect today.", "You need only be willing to look honestly, to examine carefully and to choose consciously who you wish to be."],
    emphasis: "The gate stands open.",
    big: "Welcome to StoicOs.ai",
    sub: "Inner Freedom is the destination.",
  },
  changeAnswer: "Change my answer",
};

const de = {
  "scene1": {
    "pre": "Jede Suche nach Weisheit beginnt mit einer ehrlichen Frage.",
    "h1": "Wer bin ich wirklich?",
    "body": [
      "Nicht der Mensch, für den andere Sie halten.",
      "Nicht Ihre Rolle, Ihr Besitz, Ihr Erfolg oder Ihre Vergangenheit.",
      "Sondern der Mensch, der Sie zu sein wählen, wenn das Leben Sie auf die Probe stellt."
    ],
    "scrollHint": "Scrollen Sie, um die Stoa zu betreten."
  },
  "scene2": {
    "title": "Sie haben das Tor durchschritten.",
    "intro": [
      "Nicht um dem Leben zu entfliehen,",
      "sondern um ihm mit größerer Klarheit zu begegnen."
    ],
    "line": "Hier suchen wir nicht nach schnellen Antworten.",
    "triad": [
      "Wir lernen, klarer wahrzunehmen.",
      "Wir lernen, weiser zu urteilen.",
      "Wir lernen, bewusster zu handeln."
    ]
  },
  "scene3": {
    "title": "Willkommen.",
    "name": "Mein Name ist Hipparchia.",
    "p1": "Vor mehr als zweitausend Jahren entschied ich, mein Leben nicht von Erwartungen, Besitz oder gesellschaftlichem Rang bestimmen zu lassen.",
    "p2": [
      "Ich wählte die Weisheit.",
      "Die Einfachheit.",
      "Die innere Freiheit."
    ],
    "p3": "Im Namen von Marcus Aurelius, Epiktet, Seneca und den anderen Lehrern der Stoa heiße ich Sie bei StoicOs.ai willkommen.",
    "promptLead": "Sagen Sie mir ...",
    "prompt": "Was hat Sie heute zu StoicOs.ai geführt?"
  },
  "q1": {
    "eyebrow": "Darf ich Ihnen etwas fragen?",
    "question": "Was hat Sie heute zu StoicOs.ai geführt?",
    "options": {
      "A": "Ich suche mehr Ruhe und innere Freiheit.",
      "B": "Ich möchte lernen, stärker mit Rückschlägen und Veränderung umzugehen.",
      "C": "Ich möchte mich selbst, meine Gedanken und meine Entscheidungen besser verstehen.",
      "D": "Ich bin neugierig auf den Stoizismus.",
      "E": "Ich möchte mich als Führungskraft, Unternehmer oder Mensch weiterentwickeln.",
      "F": "Ich weiß es noch nicht. Ich möchte zuerst entdecken, was StoicOs.ai ist."
    }
  },
  "branches": {
    "A": {
      "question": "Wo erleben Sie derzeit die größte Unruhe?",
      "options": [
        "In meinen Gedanken.",
        "Durch Arbeit oder Verantwortung.",
        "Durch Beziehungen oder andere Menschen.",
        "Durch Unsicherheit über die Zukunft.",
        "Ich kann es noch nicht genau benennen."
      ],
      "reaction": "Danke für Ihre Ehrlichkeit.\nInnere Ruhe entsteht nicht dadurch, dass alle Probleme verschwinden.\nSie entsteht, wenn Sie lernen zu unterscheiden, was wirklich das Ihre ist, welche Urteile Sie selbst hinzufügen und worauf Sie Ihre Aufmerksamkeit richten möchten."
    },
    "B": {
      "question": "Was möchten Sie vor allem lernen?",
      "options": [
        "Ruhiger zu reagieren, wenn etwas misslingt.",
        "Mit Verlust oder Veränderung umzugehen.",
        "Weniger abhängig von Umständen zu werden.",
        "Meinen Mut und meine Widerstandskraft zu stärken.",
        "Ich weiß es noch nicht genau."
      ],
      "reaction": "Widrigkeit enthüllt nicht nur, was uns widerfährt.\nSie enthüllt auch, welche Überzeugungen, Erwartungen und Ängste uns innerlich leiten.\nDie Stoa lehrt uns nicht, gefühllos zu werden, sondern fester stehen zu lernen."
    },
    "C": {
      "question": "Worüber möchten Sie mehr Klarheit gewinnen?",
      "options": [
        "Über meine Gedanken und Gefühle.",
        "Über meine wiederkehrenden Muster.",
        "Über meine Entscheidungen.",
        "Über meine Werte und meinen Charakter.",
        "Über meine Lebensrichtung."
      ],
      "reaction": "Selbsterkenntnis beginnt nicht mit einem Urteil darüber, wer Sie sind.\nSie beginnt mit Aufmerksamkeit.\nIndem Sie Ihre Eindrücke, Gedanken und Entscheidungen prüfen, wird sichtbar, was Sie bewusst bewahren möchten und was Sie nicht länger mittragen müssen."
    },
    "D": {
      "question": "Was spricht Sie am meisten an?",
      "options": [
        "Die antiken Philosophen.",
        "Praktische Weisheit für das tägliche Leben.",
        "Disziplin und mentale Stärke.",
        "Die vier Tugenden.",
        "Ich weiß noch fast nichts über die Stoa."
      ],
      "reaction": "Neugier ist ein würdiger Anfang.\nSie müssen noch nichts glauben oder mit Gewissheit wissen.\nInnerhalb der Stoa sind Sie eingeladen zu prüfen, zu üben und selbst zu beurteilen, welche Einsichten im täglichen Leben Bestand haben."
    },
    "E": {
      "question": "Was möchten Sie als Erstes stärken?",
      "options": [
        "Mit größerer Klarheit entscheiden.",
        "Unter Druck die Ruhe bewahren.",
        "Gerechter führen.",
        "Besser mit Konflikten umgehen.",
        "Mehr Disziplin und Selbstbeherrschung entwickeln."
      ],
      "reaction": "Führung beginnt nicht mit Macht über andere.\nSie beginnt mit der Führung Ihres eigenen Urteils, Verhaltens und Charakters.\nWer sich selbst nicht führen kann, wird auch anderen nur schwer mit Weisheit dienen können."
    },
    "F": {
      "question": null,
      "options": [],
      "reaction": "Das ist ganz in Ordnung.\nWeisheit beginnt selten mit Gewissheit.\nOft beginnt sie mit der ehrlichen Einsicht, dass wir noch nicht genau wissen, wonach wir suchen.\nNehmen Sie sich ruhig Zeit.\nSie müssen heute nichts entscheiden."
    }
  },
  "advice": {
    "title": "Ein passender erster Schritt",
    "standard": "Auf Grundlage dessen, was Sie mir erzählt haben, schlage ich vor, dass Sie mit der ersten Lektion der Logik beginnen.\nNicht weil dort alle Antworten gegeben werden.\nSondern weil klares Denken zu lernen den Anfang jedes weiteren Schrittes bildet.",
    "bullets": [
      "was Sie tatsächlich wahrnehmen;",
      "welche Bedeutung Sie dem selbst geben;",
      "und wann Sie einem ersten Eindruck zustimmen sollten oder nicht."
    ],
    "bulletsIntro": "In dieser ersten Lektion lernen Sie zu prüfen:",
    "free": "Sie können diese Einführungslektion kostenlos absolvieren.",
    "soft": "Sie müssen heute noch nichts Endgültiges entscheiden.\nWenn Sie dennoch einen ersten Schritt tun möchten, schlage ich vor, dass Sie sich in Ruhe mit der ersten Lektion der Logik vertraut machen.\nDort beginnt die Übung nicht mit Antworten, sondern mit dem Lernen, klar zu sehen."
  },
  "paths": {
    "title": "Wie möchten Sie beginnen?",
    "intro": [
      "Jeder Weg zur Weisheit beginnt anders.",
      "Wählen Sie den ersten Schritt, der jetzt zu Ihnen passt."
    ],
    "cards": [
      {
        "id": "logic",
        "title": "Beginnen Sie mit der ersten Lektion der Logik",
        "body": "Machen Sie sich kostenlos mit den Grundlagen klarer Wahrnehmung, Prüfung und Urteilsbildung vertraut.",
        "cta": "Die erste Lektion ausprobieren"
      },
      {
        "id": "mystoicos",
        "title": "Begegnen Sie Ihren Mentoren und beginnen Sie Ihr Journal",
        "body": "Lernen Sie Marcus Aurelius, Epiktet, Seneca und Hipparchia kennen.\nNutzen Sie das Journal, um Ihre Gedanken, Entscheidungen und täglichen Erfahrungen zu prüfen.",
        "cta": "Erstellen Sie ein kostenloses Konto in My StoicOs",
        "ctaLoggedIn": "My StoicOs öffnen"
      },
      {
        "id": "virtueguide",
        "title": "Laden Sie den kostenlosen Virtue Guide herunter",
        "body": "Nehmen Sie die stoische Praxis mit in den Alltag.\nNutzen Sie den Virtue Guide für tägliche Reflexion, Begleitung und praktische Übungen auf Ihrem Telefon.",
        "cta": "Virtue Guide kostenlos herunterladen",
        "note": "Erhältlich im Apple App Store und bei Google Play."
      },
      {
        "id": "newsletter",
        "title": "Ich möchte mir zunächst in Ruhe Zeit nehmen",
        "body": "Vielleicht möchten Sie alles zuerst auf sich wirken lassen.\nDas ist überhaupt kein Problem.\nNehmen Sie sich gern die Zeit zu entscheiden, ob Sie den Weg praktischer Weisheit gehen möchten.",
        "extra": "Über unseren Newsletter erhalten Sie ruhige, gehaltvolle Beiträge über praktische Weisheit und die Anwendung der Stoa im modernen Leben.",
        "cta": "Den Newsletter erhalten",
        "unsub": "Sie können sich jederzeit wieder abmelden."
      }
    ]
  },
  "closing": {
    "lines": [
      "Welchen ersten Schritt Sie auch wählen:",
      "Sie müssen heute nicht vollkommen sein.",
      "Sie brauchen nur die Bereitschaft, ehrlich hinzusehen, sorgfältig zu prüfen und bewusst zu wählen, wer Sie sein möchten."
    ],
    "emphasis": "Das Tor steht offen.",
    "big": "Willkommen bei StoicOs.ai",
    "sub": "Innere Freiheit ist das Ziel."
  },
  "changeAnswer": "Meine Antwort ändern"
};

const fr = {
  "scene1": {
    "pre": "Toute quête de sagesse commence par une question sincère.",
    "h1": "Qui suis-je réellement ?",
    "body": [
      "Non pas ce que les autres disent que vous êtes.",
      "Ni votre fonction, vos biens, votre réussite ou votre passé.",
      "Mais celui que vous choisissez d’être lorsque la vie vous met à l’épreuve."
    ],
    "scrollHint": "Faites défiler pour entrer dans la Stoa."
  },
  "scene2": {
    "title": "Vous avez franchi la porte.",
    "intro": [
      "Non pour échapper à la vie,",
      "mais pour lui faire face avec plus de clarté."
    ],
    "line": "Ici, nous ne cherchons pas de réponses rapides.",
    "triad": [
      "Nous apprenons à mieux observer.",
      "Nous apprenons à mieux juger.",
      "Nous apprenons à mieux agir."
    ]
  },
  "scene3": {
    "title": "Bienvenue.",
    "name": "Je m’appelle Hipparchia.",
    "p1": "Il y a plus de deux mille ans, j’ai choisi de ne pas laisser ma vie être déterminée par les attentes, les possessions ou le statut social.",
    "p2": [
      "J’ai choisi la sagesse.",
      "La simplicité.",
      "La liberté intérieure."
    ],
    "p3": "Au nom de Marc Aurèle, d’Épictète, de Sénèque et des autres maîtres de la Stoa, je vous souhaite la bienvenue sur StoicOs.ai.",
    "promptLead": "Dites-moi...",
    "prompt": "Qu’est-ce qui vous a amené aujourd’hui à StoicOs.ai ?"
  },
  "q1": {
    "eyebrow": "Puis-je vous poser une question ?",
    "question": "Qu’est-ce qui vous a amené aujourd’hui à StoicOs.ai ?",
    "options": {
      "A": "Je cherche plus de calme et de liberté intérieure.",
      "B": "Je veux apprendre à faire face plus solidement à l’adversité et au changement.",
      "C": "Je veux mieux me comprendre, ainsi que mes pensées et mes choix.",
      "D": "Je suis curieux du stoïcisme.",
      "E": "Je veux me développer comme dirigeant, entrepreneur ou être humain.",
      "F": "Je ne le sais pas encore. Je veux d’abord découvrir ce qu’est StoicOs.ai."
    }
  },
  "branches": {
    "A": {
      "question": "Où ressentez-vous actuellement le plus de trouble ?",
      "options": [
        "Dans mes pensées.",
        "À cause du travail ou des responsabilités.",
        "À cause des relations ou des autres.",
        "À cause de l’incertitude face à l’avenir.",
        "Je ne peux pas encore le nommer précisément."
      ],
      "reaction": "Je vous remercie de votre sincérité.\nLa paix intérieure ne naît pas parce que tous les problèmes disparaissent.\nElle naît lorsque vous apprenez à discerner ce qui dépend réellement de vous, quels jugements vous y ajoutez vous-même, et vers quoi vous souhaitez diriger votre attention."
    },
    "B": {
      "question": "Qu’aimeriez-vous surtout apprendre ?",
      "options": [
        "À réagir plus calmement lorsque quelque chose contrarie mes attentes.",
        "À faire face à la perte ou au changement.",
        "À dépendre moins des circonstances.",
        "À renforcer mon courage et ma résilience.",
        "Je ne le sais pas encore précisément."
      ],
      "reaction": "L’adversité ne révèle pas seulement ce qui nous arrive.\nElle révèle aussi quelles croyances, attentes et peurs nous gouvernent intérieurement.\nLa Stoa ne nous apprend pas à devenir insensibles, mais à nous tenir plus fermement."
    },
    "C": {
      "question": "Sur quoi souhaitez-vous gagner en clarté ?",
      "options": [
        "Mes pensées et mes émotions.",
        "Mes schémas récurrents.",
        "Mes décisions.",
        "Mes valeurs et mon caractère.",
        "Ma direction dans la vie."
      ],
      "reaction": "La connaissance de soi ne commence pas par un jugement sur ce que vous êtes.\nElle commence par l’attention.\nEn examinant vos impressions, vos pensées et vos choix, il devient visible ce que vous souhaitez consciemment conserver et ce que vous n’avez plus besoin de suivre."
    },
    "D": {
      "question": "Qu’est-ce qui vous attire le plus ?",
      "options": [
        "Les philosophes anciens.",
        "La sagesse pratique pour la vie quotidienne.",
        "La discipline et la force mentale.",
        "Les quatre vertus.",
        "Je ne sais encore presque rien de la Stoa."
      ],
      "reaction": "La curiosité est un commencement digne.\nVous n’avez encore rien à croire ni aucune certitude à avoir.\nAu sein de la Stoa, vous êtes invité à examiner, à pratiquer et à juger par vous-même quels enseignements résistent à l’épreuve de la vie quotidienne."
    },
    "E": {
      "question": "Que souhaitez-vous renforcer en premier ?",
      "options": [
        "Décider avec plus de clarté.",
        "Garder votre calme sous la pression.",
        "Diriger avec plus de justice.",
        "Mieux gérer les conflits.",
        "Développer davantage de discipline et de maîtrise de soi."
      ],
      "reaction": "Le leadership ne commence pas par le pouvoir sur les autres.\nIl commence par la maîtrise de votre propre jugement, de votre conduite et de votre caractère.\nCelui qui ne peut se conduire lui-même aura aussi du mal à servir les autres avec sagesse."
    },
    "F": {
      "question": null,
      "options": [],
      "reaction": "Ce n’est pas un problème.\nLa sagesse commence rarement par la certitude.\nSouvent, elle commence par la reconnaissance sincère que nous ne savons pas encore précisément ce que nous cherchons.\nPrenez le temps qu’il vous faut.\nVous n’avez rien à décider aujourd’hui."
    }
  },
  "advice": {
    "title": "Un premier pas approprié",
    "standard": "D’après ce que vous m’avez confié, je vous propose de commencer par la première leçon de Logique.\nNon parce que toutes les réponses s’y trouvent.\nMais parce qu’apprendre à penser avec clarté constitue le commencement de toute étape ultérieure.",
    "bullets": [
      "ce que vous percevez réellement ;",
      "quel sens vous lui donnez vous-même ;",
      "et quand vous devez, ou non, donner votre assentiment à une première impression."
    ],
    "bulletsIntro": "Dans cette première leçon, vous apprendrez à examiner :",
    "free": "Vous pouvez suivre cette leçon d’introduction gratuitement.",
    "soft": "Vous n’avez rien de définitif à choisir aujourd’hui.\nSi vous souhaitez néanmoins faire un premier pas, je vous propose de découvrir sereinement la première leçon de Logique.\nL’exercice n’y commence pas par des réponses, mais par l’apprentissage d’un regard clair."
  },
  "paths": {
    "title": "Comment souhaitez-vous commencer ?",
    "intro": [
      "Chaque chemin vers la sagesse commence différemment.",
      "Choisissez le premier pas qui vous convient en ce moment."
    ],
    "cards": [
      {
        "id": "logic",
        "title": "Commencer par la première leçon de Logique",
        "body": "Découvrez gratuitement les fondements d’une perception claire, de l’examen et du jugement.",
        "cta": "Essayer la première leçon"
      },
      {
        "id": "mystoicos",
        "title": "Rencontrez vos mentors et commencez votre journal",
        "body": "Faites la connaissance de Marc Aurèle, Épictète, Sénèque et Hipparchia.\nUtilisez le journal pour examiner vos pensées, vos choix et vos expériences quotidiennes.",
        "cta": "Créer un compte gratuit dans My StoicOs",
        "ctaLoggedIn": "Ouvrir My StoicOs"
      },
      {
        "id": "virtueguide",
        "title": "Télécharger le Virtue Guide gratuit",
        "body": "Emportez la pratique stoïcienne dans votre vie quotidienne.\nUtilisez le Virtue Guide pour la réflexion quotidienne, l’accompagnement et des exercices pratiques sur votre téléphone.",
        "cta": "Télécharger gratuitement Virtue Guide",
        "note": "Disponible sur l’Apple App Store et Google Play."
      },
      {
        "id": "newsletter",
        "title": "Je souhaite d’abord faire connaissance à mon rythme",
        "body": "Peut-être souhaitez-vous d’abord laisser tout cela décanter.\nCela ne pose aucun problème.\nPrenez le temps de déterminer si vous souhaitez emprunter le chemin de la sagesse pratique.",
        "extra": "Par notre newsletter, vous recevrez des contributions sereines et substantielles sur la sagesse pratique et l’application de la Stoa dans la vie moderne.",
        "cta": "Recevoir la newsletter",
        "unsub": "Vous pourrez vous désinscrire à tout moment."
      }
    ]
  },
  "closing": {
    "lines": [
      "Quel que soit le premier pas que vous choisissez :",
      "vous n’avez pas à être parfait aujourd’hui.",
      "Il vous suffit d’être disposé à regarder avec sincérité, à examiner avec soin et à choisir consciemment qui vous voulez être."
    ],
    "emphasis": "La porte demeure ouverte.",
    "big": "Bienvenue sur StoicOs.ai",
    "sub": "La liberté intérieure est la destination."
  },
  "changeAnswer": "Modifier ma réponse"
};

const es = {
  "scene1": {
    "pre": "Toda búsqueda de sabiduría comienza con una pregunta honesta.",
    "h1": "¿Quién es usted en verdad?",
    "body": [
      "No quien otros dicen que es.",
      "No su función, sus posesiones, su éxito ni su pasado.",
      "Sino quien usted elige ser cuando la vida lo pone a prueba."
    ],
    "scrollHint": "Desplácese para entrar en la Stoa."
  },
  "scene2": {
    "title": "Ha cruzado la puerta.",
    "intro": [
      "No para escapar de la vida,",
      "sino para afrontarla con mayor claridad."
    ],
    "line": "Aquí no buscamos respuestas rápidas.",
    "triad": [
      "Aprendemos a observar con mayor claridad.",
      "Aprendemos a juzgar mejor.",
      "Aprendemos a actuar con mayor acierto."
    ]
  },
  "scene3": {
    "title": "Bienvenido.",
    "name": "Mi nombre es Hipparchia.",
    "p1": "Hace más de dos mil años, elegí no permitir que mi vida quedara determinada por las expectativas, las posesiones o la posición social.",
    "p2": [
      "Elegí la sabiduría.",
      "La sencillez.",
      "La libertad interior."
    ],
    "p3": "En nombre de Marcus Aurelius, Epictetus, Seneca y los demás maestros de la Stoa, le doy la bienvenida a StoicOs.ai.",
    "promptLead": "Dígame...",
    "prompt": "¿Qué lo ha traído hoy a StoicOs.ai?"
  },
  "q1": {
    "eyebrow": "¿Puedo hacerle una pregunta?",
    "question": "¿Qué lo ha traído hoy a StoicOs.ai?",
    "options": {
      "A": "Busco más calma y libertad interior.",
      "B": "Quiero aprender a afrontar mejor la adversidad y el cambio.",
      "C": "Quiero comprenderme mejor a mí mismo, a mis pensamientos y a mis decisiones.",
      "D": "Siento curiosidad por el estoicismo.",
      "E": "Quiero desarrollarme como líder, emprendedor o ser humano.",
      "F": "Todavía no lo sé. Primero quiero descubrir qué es StoicOs.ai."
    }
  },
  "branches": {
    "A": {
      "question": "¿Dónde experimenta actualmente mayor inquietud?",
      "options": [
        "En mis pensamientos.",
        "Por el trabajo o la responsabilidad.",
        "Por las relaciones u otras personas.",
        "Por la incertidumbre acerca del futuro.",
        "Todavía no puedo nombrarlo con precisión."
      ],
      "reaction": "Gracias por su honestidad.\nLa calma interior no surge porque todos los problemas desaparezcan.\nSurge cuando usted aprende a distinguir qué le pertenece verdaderamente, qué juicios añade por sí mismo y hacia dónde desea dirigir su atención."
    },
    "B": {
      "question": "¿Qué desea aprender sobre todo?",
      "options": [
        "A reaccionar con más calma cuando algo sale mal.",
        "A afrontar la pérdida o el cambio.",
        "A depender menos de las circunstancias.",
        "A fortalecer mi valor y mi resiliencia.",
        "Todavía no lo sé con precisión."
      ],
      "reaction": "La adversidad no solo revela lo que nos sucede.\nTambién revela qué creencias, expectativas y temores nos guían interiormente.\nLa Stoa no nos enseña a volvernos insensibles, sino a aprender a mantenernos más firmes."
    },
    "C": {
      "question": "¿Sobre qué le gustaría obtener mayor claridad?",
      "options": [
        "Mis pensamientos y emociones.",
        "Mis patrones recurrentes.",
        "Mis decisiones.",
        "Mis valores y mi carácter.",
        "Mi rumbo en la vida."
      ],
      "reaction": "El conocimiento de sí mismo no comienza con un juicio acerca de quién es usted.\nComienza con la atención.\nAl examinar sus impresiones, pensamientos y decisiones, se vuelve visible qué desea conservar conscientemente y qué ya no necesita seguir."
    },
    "D": {
      "question": "¿Qué es lo que más le atrae?",
      "options": [
        "Los filósofos antiguos.",
        "La sabiduría práctica para la vida diaria.",
        "La disciplina y la fortaleza mental.",
        "Las cuatro virtudes.",
        "Todavía no sé casi nada sobre la Stoa."
      ],
      "reaction": "La curiosidad es un comienzo digno.\nUsted aún no necesita creer nada ni estar seguro de nada.\nDentro de la Stoa, se le invita a examinar, practicar y juzgar por sí mismo qué ideas se sostienen en la vida cotidiana."
    },
    "E": {
      "question": "¿Qué le gustaría fortalecer primero?",
      "options": [
        "Decidir con mayor claridad.",
        "Mantener la calma bajo presión.",
        "Liderar con mayor justicia.",
        "Gestionar mejor los conflictos.",
        "Desarrollar más disciplina y autodominio."
      ],
      "reaction": "El liderazgo no comienza con el poder sobre los demás.\nComienza con el gobierno de su propio juicio, conducta y carácter.\nQuien no puede gobernarse a sí mismo, difícilmente podrá servir a otros con sabiduría."
    },
    "F": {
      "question": null,
      "options": [],
      "reaction": "No hay problema.\nLa sabiduría rara vez comienza con certeza.\nA menudo comienza con el reconocimiento honesto de que todavía no sabemos con precisión qué buscamos.\nTómese su tiempo.\nHoy no tiene que decidir nada."
    }
  },
  "advice": {
    "title": "Un primer paso adecuado",
    "standard": "Sobre la base de lo que me ha dicho, le sugiero que comience con la primera lección de Lógica.\nNo porque allí se den todas las respuestas.\nSino porque aprender a pensar con claridad constituye el comienzo de todo paso ulterior.",
    "bullets": [
      "qué percibe usted realmente;",
      "qué significado le atribuye usted mismo;",
      "y cuándo debe o no debe asentir a una primera impresión."
    ],
    "bulletsIntro": "En esta primera lección aprenderá a examinar:",
    "free": "Puede seguir esta lección introductoria de manera gratuita.",
    "soft": "Hoy no tiene que decidir nada definitivo.\nSi aun así desea dar un primer paso, le sugiero que se familiarice con calma con la primera lección de Lógica.\nAllí, la práctica no comienza con respuestas, sino con aprender a ver con claridad."
  },
  "paths": {
    "title": "¿Cómo desea comenzar?",
    "intro": [
      "Cada camino hacia la sabiduría comienza de una manera distinta.",
      "Elija el primer paso que mejor corresponda a este momento."
    ],
    "cards": [
      {
        "id": "logic",
        "title": "Comience con la primera lección de Lógica",
        "body": "Conozca gratuitamente los fundamentos de la percepción clara, el examen y el juicio.",
        "cta": "Probar la primera lección"
      },
      {
        "id": "mystoicos",
        "title": "Conozca a sus mentores y comience su diario",
        "body": "Conozca a Marcus Aurelius, Epictetus, Seneca y Hipparchia.\nUtilice el diario para examinar sus pensamientos, decisiones y experiencias cotidianas.",
        "cta": "Cree una cuenta gratuita en My StoicOs",
        "ctaLoggedIn": "Abrir My StoicOs"
      },
      {
        "id": "virtueguide",
        "title": "Descargue la Virtue Guide gratuita",
        "body": "Lleve la práctica estoica consigo a la vida cotidiana.\nUtilice la Virtue Guide para la reflexión diaria, la orientación y los ejercicios prácticos en su teléfono.",
        "cta": "Descargar Virtue Guide gratis",
        "note": "Disponible en la Apple App Store y en Google Play."
      },
      {
        "id": "newsletter",
        "title": "Prefiero conocer esto con calma primero",
        "body": "Tal vez prefiera primero dejar que todo repose.\nEso no supone ningún problema.\nTómese el tiempo necesario para decidir si desea recorrer el camino de la sabiduría práctica.",
        "extra": "A través de nuestro boletín recibirá contribuciones serenas y sustanciales sobre la sabiduría práctica y la aplicación de la Stoa en la vida moderna.",
        "cta": "Recibir el boletín",
        "unsub": "Puede darse de baja en cualquier momento."
      }
    ]
  },
  "closing": {
    "lines": [
      "Sea cual sea el primer paso que elija:",
      "hoy no tiene que ser perfecto.",
      "Solo necesita estar dispuesto a mirar con honestidad, a examinar con cuidado y a elegir conscientemente quién desea ser."
    ],
    "emphasis": "La puerta permanece abierta.",
    "big": "Bienvenido a StoicOs.ai",
    "sub": "La libertad interior es el destino."
  },
  "changeAnswer": "Cambiar mi respuesta"
};

export const HOME_ENTRY = { nl, en, de, fr, es };
